import React from 'react'

import { ApolloProvider } from '@apollo/client'

import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'
import { t } from 'src/translations'

import { useOOClient } from 'shared/components/common/oo_client_provider/OOClientProvider'

import PageWrapper from 'public/components/default_template/PageWrapper'
import { CartContextProvider } from 'public/components/online_ordering/CartContext'
import { CompletedOrderContextProvider } from 'public/components/online_ordering/OrderContext'
import { getGlobalNavOverrideForOO } from 'public/components/online_ordering/globalNavUtils'
import OrderConfirmation from './online_ordering/confirmation/OrderConfirmation'

export const ConfirmationPageContent = ({
  nav,
  footer
}: {
  nav: React.ReactNode
  footer?: React.ReactNode
}) => {
  return (
    <div className='defaultTemplate'>
      {nav}
      <div className='whiteBackground'>
        <main
          className='confirmation'
          id='main'
          aria-label={t('confirmation-page.title')}
        >
          <OrderConfirmation />
        </main>
      </div>
      {footer}
    </div>
  )
}

const RestaurantConfirmationPage = () => {
  const { restaurant } = useRestaurant()
  const navOverride = getGlobalNavOverrideForOO(restaurant)
  return (
    <PageWrapper
      Component={ConfirmationPageContent}
      shouldShowPreviewBanner={false}
      navTypeOverride={navOverride}
    />
  )
}

export const ContextualConfirmationPage = ({
  children
}: React.PropsWithChildren<{}>) => {
  const ooClient = useOOClient()

  return (
    <ApolloProvider client={ooClient}>
      <CompletedOrderContextProvider>
        <CartContextProvider>{children}</CartContextProvider>
      </CompletedOrderContextProvider>
    </ApolloProvider>
  )
}

const ConfirmationPage = () => (
  <ContextualConfirmationPage>
    <RestaurantConfirmationPage />
  </ContextualConfirmationPage>
)
export default ConfirmationPage
